const searchform = document.querySelector('.js-searchform');

if(searchform) {
    const searchformTriggers = [...document.querySelectorAll('.js-searchform-trigger')];

    searchformTriggers.map(searchformTrigger => searchformTrigger.addEventListener('click', () => {
        if(searchform.hasAttribute('data-visible')) {
            searchform.removeAttribute('data-visible');
        } else {
            searchform.setAttribute('data-visible', '');

            setTimeout(() => {
                searchform.querySelector('input[type="text"]').focus();
            }, 200);
        }
    }));
}
